import { create } from '@wix/fedops-logger';

export const fedops = create('wix-emails-viewer');
